import angular from 'angular';

import APP_EVENTS from './constants/appEvents.constant';
import KEY_CODES from './constants/keyCodes.constants';

import httpProviderConfig from './configs/httpProvider.config';

import { AppStorage, RequestsStorage } from './services/appStorage';
import ActivitiesParser from './services/activitiesParser';
import AppAPI from './services/appAPI';
import AppAPIVersionInterceptor from './services/appAPIVersionInterceptor';
import AppAuthInterception from './services/appAuthInterception';
import AppErrorHandler from './services/appErrorHandler';
import AppEvents from './services/appEvents';
import AppResizableAreas from './services/appResizableAreas';
import AppResizableScreen from './services/appResizableScreen';
import AppRouting from './services/appRouting';
import AppSectionsStorage from './services/appSectionsStorage';
import AppSession from './services/appSession';
import AppSessionCapabilities from './services/appSessionCapabilities';
import AppUtils from './services/appUtils';
import locationUtils from './services/locationUtils';
import Passwords from './services/passwords';
import EntitiesFormatter from './services/entitiesFormatter';
import Users from './services/users';
import UsersListsManager from './services/usersLists';
import Brands from './services/brands';
import BrandsListsManager from './services/brandsLists';
import Permissions from './services/permissions';
import RequestsCache from './services/requestsCache';
import UIMessages from './services/uimessages';

import headerContainer from './containers/header.container';
import menuContainer from './containers/menu.container';
import newUserContainer from './containers/newUser.container';
import permissionsFormContainer from './containers/permissionsForm.container';
import revokeFormContainer from './containers/revokeForm.container';
import settingsContainer from './containers/settings.container';
import uimessagesContainer from './containers/uimessages.container';
import areaPlaceholder from './components/areaPlaceholder/areaPlaceholder.component';
import calendar from './components/calendar/calendar.component';
import entitiesAutocomplete from './components/entitiesAutocomplete/entitiesAutocomplete.component';
import entitiesMultipleSelector from
  './components/entitiesMultipleSelector/entitiesMultipleSelector.component';
import entitiesSelectionFilter from
  './components/entitiesSelectionFilter/entitiesSelectionFilter.component';
import dropdown from './components/dropdown/dropdown.component';
import header from './components/header/header.component';
import menu from './components/menu/menu.component';
import modalWrapper from './components/modalWrapper/modalWrapper.component';
import newUserForm from './components/newUserForm/newUserForm.component';
import permissionsForm from './components/permissionsForm/permissionsForm.component';
import permissionsSelector from './components/permissionsSelector/permissionsSelector.component';
import revokeForm from './components/revokeForm/revokeForm.component';
import scopesDropdown from './components/scopesDropdown/scopesDropdown.component';
import pills from './components/pills/pills.component';
import selectionList from './components/selectionList/selectionList.component';
import settingsForm from './components/settingsForm/settingsForm.component';
import searchbox from './components/searchbox/searchbox.component';
import sectionHeader from './components/sectionHeader/sectionHeader.component';
import sectionTableWrapper from './components/sectionTableWrapper/sectionTableWrapper.component';
import uimessages from './components/uimessages/uimessages.component';

import exceptionHandlerDecorator from './decorators/exceptionHandler.decorator';

import appOutdated from './eventsSubscribers/appOutdated';
import cleanStorage from './eventsSubscribers/cleanStorage';
import expireSession from './eventsSubscribers/expireSession';
import setTokenAndResizeScreen from './eventsSubscribers/setTokenAndResizeScreen';

const commonModule = angular.module('common', [])
.constant('APP_EVENTS', APP_EVENTS)
.constant('KEY_CODES', KEY_CODES)
.config(httpProviderConfig)
.factory('locationUtils', locationUtils)
.service('appStorage', AppStorage)
.service('requestsStorage', RequestsStorage)
.service('activitiesParser', ActivitiesParser)
.service('appAPI', AppAPI)
.service('appAPIVersionInterceptor', AppAPIVersionInterceptor)
.service('appAuthInterception', AppAuthInterception)
.service('appErrorHandler', AppErrorHandler)
.service('appEvents', AppEvents)
.service('appResizableAreas', AppResizableAreas)
.service('appResizableScreen', AppResizableScreen)
.service('appRouting', AppRouting)
.service('appSectionsStorage', AppSectionsStorage)
.service('appSession', AppSession)
.service('appSessionCapabilities', AppSessionCapabilities)
.service('appUtils', AppUtils)
.service('passwords', Passwords)
.service('entitiesFormatter', EntitiesFormatter)
.service('users', Users)
.service('usersListsManager', UsersListsManager)
.service('brands', Brands)
.service('brandsListsManager', BrandsListsManager)
.service('permissions', Permissions)
.service('requestsCache', RequestsCache)
.service('uimessages', UIMessages)
.component('headerContainer', headerContainer)
.component('menuContainer', menuContainer)
.component('newUserContainer', newUserContainer)
.component('permissionsFormContainer', permissionsFormContainer)
.component('revokeFormContainer', revokeFormContainer)
.component('settingsContainer', settingsContainer)
.component('uimessagesContainer', uimessagesContainer)
.component('areaPlaceholder', areaPlaceholder)
.component('calendar', calendar)
.component('entitiesAutocomplete', entitiesAutocomplete)
.component('entitiesMultipleSelector', entitiesMultipleSelector)
.component('entitiesSelectionFilter', entitiesSelectionFilter)
.component('dropdown', dropdown)
.component('header', header)
.component('menu', menu)
.component('modalWrapper', modalWrapper)
.component('newUserForm', newUserForm)
.component('permissionsForm', permissionsForm)
.component('permissionsSelector', permissionsSelector)
.component('revokeForm', revokeForm)
.component('scopesDropdown', scopesDropdown)
.component('pills', pills)
.component('selectionList', selectionList)
.component('settingsForm', settingsForm)
.component('searchbox', searchbox)
.component('sectionHeader', sectionHeader)
.component('sectionTableWrapper', sectionTableWrapper)
.component('uimessages', uimessages)
.decorator('$exceptionHandler', exceptionHandlerDecorator)
.run(appOutdated)
.run(cleanStorage)
.run(expireSession)
.run(setTokenAndResizeScreen);

export default commonModule.name;
